import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42c1f56e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-min-h-[50px] tw-justify-center tw-items-center tw-gap-[25px]" }
const _hoisted_2 = { class: "role-topic-title" }
const _hoisted_3 = { class: "role-topic-role" }

import { routers } from "@/utils/constants";

/** components */
import IconRight from "@/components/common/globalSearch/menuSearch/iconChevronRight.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'roleTopic',
  props: {
    data: {}
  },
  emits: ["close-menu"],
  setup(__props: any, { emit }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `${_unref(routers).settingTeamRoles}/manage/${_ctx.data?.roleId}`,
    class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-cursor-pointer !tw-no-underline",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close-menu')), ["stop"]))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.data?.roleName), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.data?.permissionLevel), 1)
        ])
      ]),
      _createVNode(IconRight)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})